/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"], o = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], t = "Años", n = "Año", s = "Mes", a = "Semana", r = "Días", c = "Día", d = "Hoy", i = "No hay evento", y = "Todo el día", M = "Borrar", l = "Crear un evento", m = "dddd D MMMM YYYY", b = {
  weekDays: e,
  months: o,
  years: t,
  year: n,
  month: s,
  week: a,
  days: r,
  day: c,
  today: d,
  noEvent: i,
  allDay: y,
  deleteEvent: M,
  createEvent: l,
  dateFormat: m
};
export {
  y as allDay,
  l as createEvent,
  m as dateFormat,
  c as day,
  r as days,
  b as default,
  M as deleteEvent,
  s as month,
  o as months,
  i as noEvent,
  d as today,
  a as week,
  e as weekDays,
  n as year,
  t as years
};
